import OverlayLoading from 'components/atoms/OverlayLoading'
import HomePage from 'components/templates/navigationPageTemplates/HomePage'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  CALENDAR_OAUTH_STORAGE_KEY,
  CALENDAR_OAUTH_TOKEN_PROVIDERS,
  CALENDER_OAUTH_TOKEN_URL
} from 'services/constants'
import { postRequest } from 'utils/api'
const UserCalendarEvents = () => {
  const [params] = useSearchParams()
  const [loading, setLoading] = useState(false)

  const fetchEvents = async () => {
    setLoading(true)
    const code = params.get('code')
    if (code) {
      const requestBody = {
        provider: CALENDAR_OAUTH_TOKEN_PROVIDERS.MICROSOFT,
        code
      }
      const res = await postRequest(CALENDER_OAUTH_TOKEN_URL, requestBody)
      localStorage?.setItem(
        CALENDAR_OAUTH_STORAGE_KEY.MICROSOFT,
        res.status === 201
      )
      window.close()
    }
    setLoading(false)
  }
  useEffect(() => {
    setLoading(true)
    fetchEvents()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <HomePage>
      <OverlayLoading open={loading} />
    </HomePage>
  )
}
export default UserCalendarEvents
